import React, { useState } from 'react';

import { Input, Row, Col, Button, Form, Card } from 'antd';
import { CeoEnrollmentFormGeneratedProps } from './CeoEnrollmentForm.props';
import { Container } from './CeoEnrollmentForm.style';
import { EnrollmentFormModel } from 'models/EnrollmentForm';
import { EmailTagInput, FieldData } from 'components/EmailTagInput/EmailTagInput';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import PostalAddress from 'components/PostalAddress';

const CeoEnrollmentFormView = (
  props: CeoEnrollmentFormGeneratedProps
): JSX.Element => {
  const [form] = Form.useForm();

  if (props.isLoading) return <>Loading...</>;

  return (
    <Container>
      <Form
        form={form}
        layout="vertical"
        onFinish={props.onSubmitForm}
        onFinishFailed={(err: any) => console.log('onFinishFailed: ', err)}
        initialValues={props.enrollmentForm}
      >
        <Row
          justify="center"
          align="middle"
          style={{ width: '100%', margin: '18px 0 8px 0' }}
        >
          <Col span={24}>
            <Form.Item
              name='ceoName'
              label='CEO First Name'
              rules={[{ required: true, message: 'Required' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name='ceoLastName'
              label='CEO Last Name'
              rules={[{ required: true, message: 'Required' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name='ceoEmail'
              label='CEO Email'
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: 'Please enter a valid email'
                }
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item name='ceoContactNumber' label= 'CEO Contact Number'>
              <PhoneInput
                placeholder="Enter phone number"
                onChange={phone => form.setFieldsValue({ 'ceoContactNumber': phone })}
              />
            </Form.Item>

            <Form.Item name='companyName' label='Company Name'>
              <Input/>
            </Form.Item>

            <Form.Item name='companyAddress' label='Company Address'>
              <PostalAddress
                address={props?.enrollmentForm?.companyAddress}
                onChange={(companyAddress: any) => form.setFieldsValue({ companyAddress })
                }
              />
            </Form.Item>

            <Form.Item name='companyWebsiteUrl' label='Company Website URL'>
              <Input/>
            </Form.Item>

            <Form.Item
              name='employeeEmails'
              label='Growth DX Participants Emails (Type email, then press enter)'
              rules={[{ required: true, message: 'Required' }]}
            >
              {
                <EmailTagInput
                  name='employeeEmails'
                  value={props.enrollmentForm?.employeeEmails}
                  onChange={(newTags) => {
                    form.setFieldsValue({ employeeEmails: newTags });
                  }}
                  onError={(errors: FieldData[]) => {
                    //form.setFields([{ name: 'employeeEmails', errors: ['Please enter a valid email'] }]);
                    form.setFields(errors);
                  }}
                />
              }
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={props.isSubmitting}
              >
                Submit
              </Button>
            </Form.Item>
          </Col>
        </Row>

      </Form>
    </Container>
  );
};

export default CeoEnrollmentFormView;
